module.exports = __webpack_public_path__ + "img/dypitch-4-mobile.bc312a12.jpg";